import React, { Suspense } from 'react';
import ErrorBoundary from './lib/asyncBounrdary/errorBoundary';
import 'antd/dist/antd.less';
import './antDesignCustom.css';
import LXRouter from './0_presentation/core/router';
import { ThemeProvider } from 'styled-components';

import { Route, Routes } from 'react-router-dom';
import IntroRouter from './0_presentation/intro/router';
import langAtom from './1_application/core/langAtom';
import { useRecoilValue } from 'recoil';
import { enTheme, indTheme } from './0_presentation/core/designSystem/theme';

const App: React.FC = () => {
  const lang = useRecoilValue(langAtom);

  return (
    <ThemeProvider theme={lang === 'english' ? enTheme : indTheme}>
      <ErrorBoundary>
        <Suspense>
          <Routes>
            <Route path="/*" element={<IntroRouter></IntroRouter>} />
            <Route path="/clinic/*" element={<LXRouter></LXRouter>} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default App;
